<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>처방 내역</h2>
      </div>

      <article class="view cmnity">
        <div class="search_box" style="flex-wrap: wrap">
          <p class="w100 mb20">
            총
            <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
          </p>

          <div class="form_inline">
            <div class="flex items-center">
              <span class="mw80 fwb">처방명</span>
              <input
                type="text"
                class="form_control"
                placeholder="비방명을 입력하세요."
                v-model="searchInfo.prescribe_nm"
                @keyup.enter="fn_search"
              />
              <span class="mw80 fwb ml20">환자명</span>
              <input
                type="text"
                class="form_control"
                placeholder="환자명을 입력하세요."
                v-model="searchInfo.patient_nm"
                @keyup.enter="fn_search"
              />
            </div>
          </div>
          <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
          <div class="flex items-center mt10">
            <span class="mw80 fwb">처방일자</span>
            <Datepicker class="dp-wide" v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
            <span class="ml10 mr10">~</span>
            <Datepicker class="dp-wide"  v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'" />
              <div class="flex items-center mt10">
                <span class="mw80 fwb ml20">차트번호</span>
              <input
                type="text"
                class="form_control"
                placeholder="차트번호를 입력하세요."
                v-model="searchInfo.patient_chart_no"
                @keyup.enter="fn_search"
              />
              </div>
          </div>
        </div>

        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>주문번호</th>
                    <th>분류</th>
                    <th>처방명</th>
                    <th>결제금액</th>
                    <th>처방일시</th>
                    <th>환자명</th>
                    <th>차트번호</th>
                    <th>첩수</th>
                    <th>팩수</th>
                    <th>진행사항</th>
                    <th>결제상태</th>
                    <th>배송조회</th>
<!--                    <th>비방리뷰</th>-->
                    <th>결제취소</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="prescriptionList.length == 0">
                    <td colspan="11"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in prescriptionList"
                    :key="index"
                    @click="fn_move_dtl_page(item.prescribe_seq)"
                  >
                  <!-- <tr
                    v-for="(item, index) in prescriptionList"
                    :key="index"
                    @click="fn_move_dtl_page(item.prescribe_seq)"
                  > -->
                    <td>
                      <span>{{ (searchInfo.pageInfo.totPage-((searchInfo.pageInfo.page-1) * searchInfo.pageInfo.pageSize)) - index }}</span>
                    </td>
                    <td>
                      <span>{{ item.order_code }}</span>
                    </td>
                    <td>
                      <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                      <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                      <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
                    </td>
                    <td class="ac">
                      <span :class="{ 'text-strike': item.payment_status == 'CANC' }">{{ item.prescribe_nm }}</span> <span v-if="item.prescribe_type == 'P'" :class="{ 'text-strike': item.payment_status == 'CANC' }"> × {{item.item_quantity}} </span>
                    </td>
                    <td>
                      <span>{{ fn_comma_won(item.total_payment) }}</span>
                    </td>
                    <td>
                      <span>{{ item.reg_dt }}</span>
                    </td>
                    <td>
                      <span>{{ item.patient_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.patient_chart_no }} </span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_pack_cnt }}</span>
                    </td>
                    <td>
                      <span>{{ item.packs_cnt }}</span>
                    </td>
                    <td>
                      <div class="flex justify-center">
                        <button class="bdge bd_blue">{{item.work_status_nm}}</button>
                      </div>
                    </td>
                    <td>
                      <span :class="item.payment_status == 'CANC' ? 'font_red' : ''">{{ item.payment_status_nm }}</span>
                    </td>
                    <td @click.stop>
                      <div class="flex justify-center">
                        <button v-if="item.delivery_no != ''" class="bdge bd_brown" @click="fn_open_delivery(item)">배송조회</button>
                      </div>
                    </td>
<!--                    <td @click.stop>-->
<!--                      <div class="flex justify-center">-->
<!--                        <button v-if="item.payment_status =='COMP' && item.recipe_review_status == 'R'"  class="bdge blink-btn" @click="fn_open_review(item)" >비방리뷰</button>-->
<!--                        <span v-else>일반탕전</span>-->
<!--                      </div>-->
<!--                    </td>-->
                    <td @click.stop>
                      <button class="icon icon_del" v-if="item.work_status == 'P1' && (item.payment_status =='COMP' || item.payment_status =='WAIT')" @click="fn_pament_cancel(item)"></button>
<!--                      <button class="icon icon_del" v-if="item.prescribe_type =='P' && item.work_status == 'P5' && item.payment_status =='COMP'" @click="fn_pament_cancel(item)"></button>-->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>

    <delivery-tracking-modal
      :deliveryNo="selectedDeliveryNo"
      :deliveryCompanyCd="selectedDeliveryCompanyCd"
    />

    <bibang-review-reg-modal ref="bibangReviewRegModal" @saved="fn_search" />

    <alert-modal
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      v-on:update:showSetting="fn_showSet"
    />
    <alert-modal 
          :id="'confirm'"
          :text="'결제를 취소하시겠습니까?'" 
          :btnLeft="'취소'" 
          :btnRight="'확인'" 
          :oneBtn="true"
          :isShow="comfirmAlertShow"
          :className="'btn_brown'"
          @callback="fn_alert_close"
      />
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"
import Datepicker from "@/components/Datepicker.vue";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
import DeliveryTrackingModal from "@/modal/user/deliveryTrackingModal.vue";
import BibangReviewRegModal from "@/modal/user/bibangReviewRegModal.vue";

export default {
  components: {
    Pagination,
    Datepicker,
    AlertModal,
    DeliveryTrackingModal,
    BibangReviewRegModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      searchInfo : {
        prescribe_nm : '',
        patient_nm : '',
        clinic_doctor_id : '',
        startDate : '',
        endDate : '',
        patient_chart_no : '',
        pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
        }                
      },
      pagingShow : false,
      prescriptionList: [],

      cancelOrderInfo : {}, // 취소할 주문요청

      comfirmAlertShow : false,
      cancel_prescribe_seq : '',

      selectedDeliveryNo: '',
      selectedDeliveryCompanyCd: ''
    };
  },
  created(){
    
    let searchInfoStore = this.$store.getters['detailSearchInfo/getSearchInfo'];   
    
    console.log('@@@@@ searchInfoStore : %o',searchInfoStore);

    if(searchInfoStore != null && searchInfoStore != {} && searchInfoStore != ''){
        this.searchInfo = searchInfoStore;
    }

    this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){ 
    
      //오늘 날짜구하기
      this.searchInfo.startDate =  this.getAddMonthDate(-3);
      this.searchInfo.endDate = this.getCurrentDate();

      this.fn_search();
  },
  methods : {
    fn_search(){
          console.log("@@@ search : ",this.searchInfo);

          this.$store.dispatch('detailSearchInfo/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/user/mypage/getPrescriptionHistoryList", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.prescriptionList = res.data.prescriptionList;

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_dtl_page(seq){
          this.$store.commit('detailSearchInfo/setSearchId', seq);
          this.$router.push({ name : 'PrescriptionDetail'});
      },
      fn_open_review(item){
        this.$refs.bibangReviewRegModal.open(item, this.searchInfo.clinic_doctor_id);
      },
      fn_open_delivery(item) {
        this.selectedDeliveryNo = item.delivery_no;
        //this.selectedDeliveryCompanyCd = item.delivery_company_code;
        this.selectedDeliveryCompanyCd = "06";    // 당분간 로젠 택배로 고정

        this.$bvModal.show('deliveryTrackingModal');
      },
      fn_pament_cancel(item){

        this.cancelOrderInfo = item;
        this.comfirmAlertShow = true;

      },
      fn_alert_close(type){

        this.comfirmAlertShow = false;
                      
        if(type == 'ok') {

          //결제취소정보
          let param = new Object();
          param.prescribe_seq = this.cancelOrderInfo.prescribe_seq;
          param.deposit_used_price = this.cancelOrderInfo.deposit_used_price;
          param.point_used_price = this.cancelOrderInfo.point_used_price;
          param.pay_price = this.cancelOrderInfo.pay_price;
          param.order_code = this.cancelOrderInfo.order_code;
          param.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

          //카드결제일 경우 카드사 취소처리
          if (this.cancelOrderInfo.payment_type == 'CP' || this.cancelOrderInfo.payment_type == 'VB') {

            axios
                .post("/api/user/mypage/cardPaymentCancel", param)
                .then((res) => {
                  console.log("@@@@ res : %o",res);
                  if(res.data.result === '1'){
                    let msg = res.data.message;
                    this.fn_open_alert(msg);
                  }else{
                    let msg = "결제를 취소하였습니다.";
                    this.fn_open_alert(msg);
                    this.fn_search();
                  }

                })
                .catch((err) => console.log(err));
          } else {

            axios
                .post("/api/user/mypage/updatePaymentCancel", param)
                .then((res) => {
                  console.log("@@@@ res : %o",res);
                  let msg = "결제를 취소하였습니다.";
                  this.fn_open_alert(msg);

                  this.fn_search();
                })
                .catch((err) => console.log(err));
          }
        }
      },
  }
};
</script>
